
/**
 * Countdown init
 */
export async function countdownInit() {
    const countdowns = document.querySelectorAll(".js-countdown");
    if (countdowns.length) {
        let {CountDown} = await import('../countdown.js');
        countdowns.forEach(countdown => {
            let targetTime = new Date(countdown.getAttribute("data-js-countdown"));
            let days = countdown.querySelector(".js-countdown__days");
            let hours = countdown.querySelector(".js-countdown__hours");
            let minutes = countdown.querySelector(".js-countdown__minutes");
            let seconds = countdown.querySelector(".js-countdown__seconds");
    
            let updateNumbers = (time) => {
                if (days) {
                    days.textContent = time.days;
                }
    
                if (hours) {
                    hours.textContent = time.hours;
                }
    
                if (minutes) {
                    minutes.textContent = time.minutes;
                }
    
                if (seconds) {
                    seconds.textContent = time.seconds;
                }
            };
    
            let complete = () => {
    
            };
    
            let timer = new CountDown(targetTime, updateNumbers, complete);
        });
    }
}